<div class="row" style="position: relative;">
  <a data-toggle="modal" class="icon-full" (click)="openModal(insurance)" style="padding-top: 6px;">
    <i class="fa fa-gear icon-seguro"></i>
  </a>
</div>
<ng-template #insurance>
  <div class="modal-header">
    <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="onClickClose()">
      <span aria-hidden="true">&times;</span>
    </button>
    <h3>PRODUTOS</h3>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-xs-12">
        <div *ngIf="isVeiculoPrincipal">
          <div class="row">
            <div class="col-xs-10 col-xs-offset-1">
              <slider-retorno starred [retornoMax]="retornoMax" [(retorno)]="retorno"></slider-retorno>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-10 col-xs-offset-1 text-center">
              <h3>{{retorno}}</h3>
            </div>
          </div>
          <hr>
        </div>

        <div *ngIf="!isLojista || hasRouboFurto()">
          <div *ngIf="hasGrupoSeguro() && isVeiculoPrincipal">
            <div *ngFor="let grupo of filterRouboFurto()">
              <h3>{{grupo.descricao}}</h3>
              <div class="radio" *ngFor="let seg of grupo.seguros">
                <input type="radio" name="radioSeguro-{{grupo.id}}" [id]="seg.id" [value]="seg.descricao"
                  (change)="onSelectionSeguro(seg.id, grupo.id)" [checked]="checkSeguro(seg.id)">
                <label class="label-descricao" [for]="seg.id">
                    <div class="label-descricao__texto-seguros">{{seg.descricao}}</div>
                    <div class="insurance-desc" *ngIf="!isRouboFurto(grupo.id)">Limite de cobertura:
                      {{seg.valorMaximo || 0 | currency:'BRL':'symbol':'1.2-2'}}</div>
                    <div class="insurance-desc" *ngIf="isRouboFurto(grupo.id)">
                      Cobertura de até 100% da Tabela FIPE
                    </div>
                </label>
                <saiba-mais [texto]="seg.saibaMais"></saiba-mais>
              </div>
              <div class="radio">
                <input type="radio" name="radioSeguro-{{grupo.id}}" id="nenhumSeguro-{{grupo.id}}" value="NENHUM_SEGURO"
                  (change)="onSelectionSeguro(0, grupo.id)" [checked]="checkSeguroNone(grupo.id)">
                <label class="label-descricao" for="nenhumSeguro-{{grupo.id}}">NENHUM</label>
              </div>
            </div>
          </div>

          <div class="radio" *ngIf="!hasGrupoSeguro() && isVeiculoPrincipal">
            <input type="radio" name="semOpcoes" id="semOpcoes" [disabled]="true">
            <label for="semOpcoes">Não há opções</label>
            <saiba-mais [texto]="'Não há opções de seguros disponíveis para este cliente.'"></saiba-mais>
          </div>
          <hr *ngIf="isVeiculoPrincipal">

          <div *ngIf="hasGrupoAssistencia() && !isLojista">
            <div *ngFor="let grupo of gruposAssistenciasPorTipo">
              <h3>{{ grupo.descricao }} PARA O VEÍCULO {{ isVeiculoPrincipal ? 'PRINCIPAL' : indexGarantia + 1  }}</h3>
              <div class="radio" *ngFor="let assistencia of grupo.assistencias">
                <input type="radio" name="radioAssistencia-{{grupo.id}}" [id]="'assistencia-' + assistencia.id"
                  [value]="assistencia.descricao" (change)="onSelectionAssistencia(assistencia.id, grupo.id)"
                  [checked]="checkAssistencia(assistencia.id)">
                <label class="label-descricao" [for]="'assistencia-' + assistencia.id">
                  <div class="label-descricao__texto">{{assistencia.descricao}}</div>
                </label>
                <saiba-mais [texto]="assistencia.saibaMais"></saiba-mais>
              </div>
              <div class="radio">
                <input type="radio" name="radioAssistencia-{{grupo.id}}" id="nenhumAssistencia-{{grupo.id}}"
                  value="NENHUM_ASSISTENCIA" (change)="onSelectionAssistencia(0, grupo.id)"
                  [checked]="checkAssistenciaNone(grupo.id)">
                <label class="label-descricao" for="nenhumAssistencia-{{grupo.id}}">NENHUM</label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" (click)="onClickClose()" class="btn btn-border-orange pull-left" data-dismiss="modal">Voltar</button>
    <button type="button" (click)="onSaveClick()" class="btn btn-full-orange pull-right" data-dismiss="modal">Salvar</button>
  </div>

</ng-template>
